import 'react-color-palette/css';

import { type ComponentProps, memo } from 'react';
import { ColorPicker } from 'react-color-palette';

export type ColorPalettePickerProps = ComponentProps<typeof ColorPicker>;

export const ColorPalettePicker = memo((props: ColorPalettePickerProps) => {
  return <ColorPicker data-testid="COLOR_PALETTE_PICKER" {...props} />;
});

ColorPalettePicker.displayName = 'ColorPalettePicker';
